export const swapType = {
  1: 'In points',
  2: 'In money, using base currency',
  3: 'In money, using margin currency',
  4: 'In money, using group currency',
  5: 'In percentage terms, using current price',
  6: 'In percentage terms, using open price',
  7: 'In points, reopen position by close price',
  8: 'In points, reopen position by bid price',
  9: 'In money, using profit currency',
};
